// extracted by mini-css-extract-plugin
module.exports = {"style_model_item":"yearCards_style_model_item__jg_DG"};